// @flow
import type { Node } from 'react'
import * as React from 'react'
import { Motion, presets, spring } from 'react-motion'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import './styles.scss'

export type PopupProps = {
  children: React.Node,
  left: number,
  onCloseHandler: (SyntheticEvent<HTMLAnchorElement>) => void,
  top: number,
  useTouch: boolean,
  width: number
}

/**
 * Popup mit Informationen zu einer bestimmten Gemeinde.
 */
export function Popup ({
  children,
  left,
  onCloseHandler = () => {},
  top,
  useTouch = false,
  width = 300
}: PopupProps): React.Element<'div'> {
  let closeButton = null

  if (useTouch) {
    closeButton = (
      <a onTouchEnd={onCloseHandler} className='ui basic icon close button'>
        <i className='close icon' />
      </a>
    )
  }

  return (
    <div
      className='ta popup ui raised compact segment'
      style={{
        transform: `translate(${(window.innerWidth - width) *
          (left / window.innerWidth) +
          width / 2}px, ${top}px) translate(-50%, -100%) translateY(-2em)`,
        width: width
      }}
    >
      {children}
      {closeButton}
    </div>
  )
}

/**
 * Popup, but with position and numbers interpolated using React Motion.
 *
 * @param {object} props
 * @param props.top
 * @param props.left
 */
export function MotionPopup (props: PopupProps): Node {
  return (
    <Motion
      defaultStyle={{
        top: window.pageYOffset,
        left: window.innerWidth / 2 + window.pageXOffset
      }}
      style={{
        top: spring(props.top, presets.gentle),
        left: spring(props.left, presets.gentle)
      }}
    >
      {interpolatingStyle => (
        <Popup {...props} {...interpolatingStyle}>
          {props.children}
        </Popup>
      )}
    </Motion>
  )
}

export default MotionPopup
